import Vue from 'vue'
import Vuex from 'vuex'

import coreModules from '@/store/modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ...coreModules.modules
  }
})
